import React from 'react';
import { BookOpenIcon, StarIcon, CalendarIcon, UserGroupIcon, MapIcon, ShareIcon, ClockIcon, ChartBarIcon, LightBulbIcon } from '@heroicons/react/24/outline';
import MyDailyAdventure from './MyDailyAdventure';
import SuperSkillsUnlocked from './SuperSkillsUnlocked';
import MyLearningGoals from './MyLearningGoals';
import LearningInsights from './LearningInsights';
import DiscoveryZone from './DiscoveryZone';
import MyCoursesProgress from './MyCoursesProgress';
import YourNextClass from './YourNextClass';
import MyInstructors from './MyInustructors';
import AdventureMap from './AdventureMap';
import QuickTips from './QuickTips';
import StudyToolkit from './StudyToolkit';

// Component for "My Daily Adventure"
const StudentDashboard = () => {
  return (
    <div className="flex min-h-screen bg-gray-50">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left Column (2/3 width on large screens) */}
        <div className="lg:col-span-2 space-y-6">
          {/* <MyDailyAdventure /> */}
                    <SuperSkillsUnlocked />

                    <LearningInsights />

          <DiscoveryZone />
                    <MyLearningGoals />

        </div>

        {/* Right Column (1/3 width on large screens) */}
        <div className="lg:col-span-1 space-y-6">
                    <YourNextClass />

          <MyCoursesProgress />
          <MyInstructors />
          <AdventureMap />
          <QuickTips />
          <StudyToolkit />
        </div>
      </div>
    </div>
  );
};

export default StudentDashboard;
